<template>
    <header class="container">
        <router-link :to="backUrl">
            <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
            <span class="uni-button">{{ backLabel }}</span>
        </router-link>
    </header>
</template>

<script>
    export default {
        name: "RichHeaderSecondaryLevel",
        props:{
            backUrl: {
                type: String,
                default: '/'
            },
            title:{
                type: String,
                default: 'Titre de la page'
            },
            backLabel:{
                type:String,
                default: 'Retour en arrière'
            }
        }
    }
</script>

<style scoped lang="scss">
header{
    display:flex;
    height: 48px;
    justify-content: space-between;
    align-items: center;
    position:fixed;
    top:0;
    left:0;
    width: 100%;
    background: white;
    border-bottom: 1px solid var(--color-grey-light-2);
    h1{
        font-size: 1rem;
        line-height: 1.2rem;
    }
    >*:first-child{
        margin-right: 16px;
    }
    >a{
        span{
            display: none;
        }
    }
}

    @include screen-m{
        header{
            margin-bottom: 16px;
            display:block;
            height: initial;
            position:initial;
            border:none;
            padding: 0;
            h1{
                margin-top: 24px;
                font-size:1.93rem;
                line-height: 2.57rem;
            }
            >a{
                &:hover{
                    span{
                        color:var(--color-primary);
                    }
                }
                display:flex;
                align-items: center;
                span{
                    display: block;
                    margin-left: 6px;
                }
            }
        }
    }
</style>
